export { default } from './CredentialNew';
